import React from 'react';
import { Settings, Map as MapIcon, Users } from 'lucide-react';
import { useStore } from '../store';

export const SettingsPanel: React.FC = () => {
  const { activePanel, setActivePanel } = useStore();

  return (
    <div className="absolute top-4 right-4 bg-white p-4 rounded-lg shadow-lg">
      <div className="flex items-center space-x-4">
        <button
          onClick={() => setActivePanel(activePanel === 'settings' ? null : 'settings')}
          className={`p-2 rounded-lg transition-colors duration-200 ${
            activePanel === 'settings' ? 'bg-blue-500 text-white' : 'bg-gray-100 hover:bg-gray-200'
          }`}
          aria-label="マップ設定"
          title="マップ設定"
        >
          <Settings className="w-6 h-6" />
        </button>
        <button 
          onClick={() => setActivePanel(activePanel === 'map' ? null : 'map')}
          className={`p-2 rounded-lg transition-colors duration-200 ${
            activePanel === 'map' ? 'bg-blue-500 text-white' : 'bg-gray-100 hover:bg-gray-200'
          }`}
          aria-label="地図設定"
          title="地図設定"
        >
          <MapIcon className="w-6 h-6" />
        </button>
        <button 
          onClick={() => setActivePanel(activePanel === 'users' ? null : 'users')}
          className={`p-2 rounded-lg transition-colors duration-200 ${
            activePanel === 'users' ? 'bg-blue-500 text-white' : 'bg-gray-100 hover:bg-gray-200'
          }`}
          aria-label="ユーザー設定"
          title="ユーザー設定"
        >
          <Users className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};